import { render } from "./manage-sub_category.vue?vue&type=template&id=0be2b90c"
import script from "./manage-sub_category.vue?vue&type=script&lang=js"
export * from "./manage-sub_category.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__